import React, {Component} from 'react';
import {Icon, Input} from 'antd';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

class ConfirmSearch extends Component {
  state = { value: undefined };

  componentDidMount() {
    this.setState({ value: this.props.value });
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({ value: this.props.value });
    }
  }

  onChange = event => this.setState({ value: event.target.value });

  render() {
    return <Input.Search
      style={this.props.style}
      className={this.props.className}
      placeholder={this.props.placeholder || "Search..."}
      enterButton
      value={this.state.value || undefined}
      onSearch={this.props.onSearch}
      onChange={this.onChange}
    />;
  }
}

ConfirmSearch.propTypes = {
  style: PropTypes.any,
  className: PropTypes.any,
  placeholder: PropTypes.any,
  value: PropTypes.any,
  onSearch: PropTypes.func,
};

const InteractiveSearch = props => <Input
  style={props.style}
  className={props.className}
  placeholder={props.placeholder || "Search..."}
  prefix={<Icon type='search'/>}
  suffix={props.suffix}
  value={props.value}
  onChange={props.onChange}
/>;

InteractiveSearch.propTypes = {
  style: PropTypes.any,
  className: PropTypes.any,
  placeholder: PropTypes.any,
  suffix: PropTypes.any,
  value: PropTypes.string,
  onChange: PropTypes.any,
};

let debouncedFunction;

class SearchBox extends Component {
  state = { value: '' };

  static propTypes = {
    placeholder: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    onChange: PropTypes.func,
  };

  handleSearch = value => this.props.onChange && this.props.onChange(value);
  debouncedSearch = wait => {
    debouncedFunction && debouncedFunction.cancel();
    debouncedFunction = debounce(this.handleSearch, wait);
    return debouncedFunction;
  };

  setValue = value => this.setState({ value })

  emitEmpty = () => {
    this.setState({ value: '' });
    this.handleSearch('');
  };

  onSearch = (value, wait = 0) => {
    this.setState({ value: value });
    if (debounce) {
      const wait = 350 / 27 * (Math.min(Math.max(value.length, 1), 10) - 10) ** 2 + 450;
      this.debouncedSearch(value.length ? wait : value.length)(value);
    } else {
      this.handleSearch(value);
    }
  };

  render() {
    const { value } = this.state;
    const { placeholder, style, className, defaultValue, interactive } = this.props;
    const suffix = value || defaultValue ? <Icon type='close-circle' onClick={this.emitEmpty}/> : null;
    return interactive ?
      <InteractiveSearch style={style} className={className} placeholder={placeholder} suffix={suffix} value={value || defaultValue}
                         onChange={e => this.onSearch(e.target.value, true)}/> :
      <ConfirmSearch style={style} className={className} placeholder={placeholder} value={value || defaultValue}
                     onSearch={e => this.onSearch(e)}/>;
  }
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/Boilerplate/SearchBox.js